/*

Gesture based venue plan engine
Peter Perron - SolutionsTLM

INFO: This has been converted from CoffeeScript. The cleanup is not over yet!

PU = Plan unit independnant of the browser sizes

TODO:
[  ] Avoir un concept pour les couleurs de hover
[  ] Faire usage des event emitter à la place

- Job de Zoom
  - Faire en sorte que le zoom inclut le bouding box des seat + le point de la scene
  - Réduire le full sky zoom pour quand les billets sont déjà visible dans le viewport
- Block the gesture when the plan is processing
- Contextual menu (Search ticket around here)
- Message toasting with confirm
- Select seats event on click or right click
- Found ticket flash to show where they are
- Faire en sorte que le zoom de Seat inclue
- Prevent animations from being executed at the same time. (If the person touches the plan, it stops any animations except when
it's an important animation! In that latter case, touching the plan does nothing.)

 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
*/

const interact = require('interactjs'); // Gesture intraction librairie

// 2D Math lib
import { Vector2, Size2, Rect, Line2D, almostEquals } from "peet-math"
import $ from "jquery"
import { defaults, difference, drop, find } from "lodash";
import { ViewPort } from "./viewport";
import { CSSDummyStyle, cssDummyToStyle, getOffset, getSeatBoudingBox, getStylingDummy } from "./util";
import { GuidingArrow } from "./guiding-arrow-control";
import { SteadyFingerAnim } from "./steady-finger-anim-control";
import { TicketFlashAnim } from "./ticket-flash-anim";
import { PlaceIndicationAnim } from "./place-indication-anim-control";
import { ContextMenuControl, ContextMenuSettings } from "./context-menu-control";
import { EventLocationControl } from "./event-location-control";
import { SeatControl } from "./seat-control";
import { Control } from "./control";
import { PlanSeat, SeatStatusEnum } from "./plan-seat";
import { PlanSection } from "./plan-section";
import { SectionControl } from "./section-control";
//const pmath = require('peter-math-js');


const panim = require('peter-anim-js');

// docOffset = require 'document-offset' # JQuery fails doing this correctly on a lot of very recent phone. (HTC, Samsung S6, Nexxus 5...)
// Abstract animation system

//module.exports.ReactGestureVenuePlan = require './gesture-venue-plan.js'

export function getDefaultPlanSettings(): PlanSettings {
    return {
        clickableSeatMode: false,
        showDebugInfo: false
    };
}



export class GestureVenuePlan {
    public containerTag: JQuery<HTMLElement>;
    public planImgTag: JQuery<HTMLElement>;
    public canvas: HTMLCanvasElement;
    public viewPortTag: JQuery<HTMLElement>;
    public waitOverlayTag: JQuery<HTMLElement>;
    public waitSpinnerTag: JQuery<HTMLElement>;
    // public planSettings: PlanSettings = getDefaultPlanSettings();
    public debugInfo: any;
    public planSpec: PlanSpec;
    public view: ViewPort;
    public planInteract: any;
    public planZoom: number;
    public refreshInterval: any;
    public lastFrameTime: number;
    public redrawCounter: number;
    public onPlanLoaded: () => void;
    public isPlanLoaded: boolean = false;
    public onLongClick: (pointOnPlan: Vector2) => void;
    public onRightClick: (pointOnPlan: Vector2) => void;
    public onSingleClick: (pointOnPlan: Vector2) => void;
    public onSeatClick: (seat: PlanSeat) => void;
    public onSectionClick: (section: PlanSection) => void;
    public arrowsTrackMargin: number;
    public nextRedrawEvent: any;
    public autoMoveBackToPlanAnim: any;
    public userMovingPlan: boolean;
    public planInertiaCancelled: boolean;
    public mouseDown: boolean;
    public planMoveThresholdReached: boolean;
    public singleTapTimeoutDelayMS: number;
    public singleTapTimeoutID: any;
    public settings: PlanSettings = getDefaultPlanSettings();;
    public contextMenu: ContextMenuControl;
    public eventLocationCtl: any;
    public guidingArrows: any;
    public steadyFinger: any;
    public ticketSearchFlash: any;
    public placeIndicatorAnim: any;
    public otherCtlsToRender: any;
    public imgPath: string;
    public seatsBoundingBox: Rect;
    public totalPlanDragDelta: Vector2;
    public seatControls: SeatControl[];
    public seatControlsBySeatId: any;
    //public selectedSeats: PlanSeat[];
    public selectedSeatsCtl: SeatControl[];
    public selectedSeatsCtlById: { [id: number]: SeatControl };
    public sections: PlanSection[] = [];
    public sectionsCtl: SectionControl[];
    public arrowsTrackOnPlan: any;
    public arrowsTrack: any;
    public seatsLocation: any;
    public mousePos: any;
    public mousePreviousPos: any;
    public mouseMoveDelta: any;
    public hoverCtls: Control[] = null;
    public availableSeatStyle: CSSDummyStyle;
    public availableSeatHoverStyle: CSSDummyStyle;  
    public processingSeatStyle: CSSDummyStyle;
    public selectedSeatStyle: CSSDummyStyle;
    public unavailableSeatStyle: CSSDummyStyle;
    public sectionButtonStyle: [CSSDummyStyle, CSSDummyStyle] = [null, null];

    constructor(planContainerTag: HTMLElement, imgPath: string, settings: PlanSettings) {
        this.setContextMenu = this.setContextMenu.bind(this);
        this.showContextMenuAt = this.showContextMenuAt.bind(this);
        this.stop = this.stop.bind(this);
        this.moveToEvent = this.moveToEvent.bind(this);
        this.moveToSeats = this.moveToSeats.bind(this);
        this.moveToSeatsBySky = this.moveToSeatsBySky.bind(this);
        this._initLayers = this._initLayers.bind(this);
        this._initEvents = this._initEvents.bind(this);
        this.handleTap = this.handleTap.bind(this);
        this.handleSingleTap = this.handleSingleTap.bind(this);
        this.onPlanManualMove = this.onPlanManualMove.bind(this);
        this.onFingerHold = this.onFingerHold.bind(this);
        this.pointSomethingAt = this.pointSomethingAt.bind(this);
        this.startSteadyFingerAnim = this.startSteadyFingerAnim.bind(this);
        this.interruptSteadyFingerAnim = this.interruptSteadyFingerAnim.bind(this);
        this.interruptSingleTap = this.interruptSingleTap.bind(this);
        this.startTicketSearchFlash = this.startTicketSearchFlash.bind(this);
        this.triggerRedraw = this.triggerRedraw.bind(this); // Important
        this.get_BringBackView_Point = this.get_BringBackView_Point.bind(this);
        this.redraw = this.redraw.bind(this);
        this._calcAndSetGuidanceArrowPositionAndAngle = this._calcAndSetGuidanceArrowPositionAndAngle.bind(this);
        this._calcArrows = this._calcArrows.bind(this);
        this.drawDebugInfo = this.drawDebugInfo.bind(this);
        this.setEventLocation = this.setEventLocation.bind(this);
        this.setSeats = this.setSeats.bind(this);
        this.moveVPDelta = this.moveVPDelta.bind(this);
        this.move = this.move.bind(this);
        this.zoom = this.zoom.bind(this);
        this.zoomWithVPTarget = this.zoomWithVPTarget.bind(this);
        this.moveInSky = this.moveInSky.bind(this);
        this.showWait = this.showWait.bind(this);
        this.imgPath = imgPath;
        if ((planContainerTag == null)) {
            throw new Error('Gesture Venue Plan - planContainerTag is undefined');
        }
        this.lastFrameTime = new Date().getTime();
        this.redrawCounter = 0;
        this.onLongClick = null;
        this.onRightClick = null;
        this.onSingleClick = null; // This is a very single click, it won't fire on a double click
        this.arrowsTrackMargin = 60; // In viewport pixels
        this.nextRedrawEvent = null; // This is the handle to the next redraw event.
        this.autoMoveBackToPlanAnim = null; // This is the animation that brings the view on the plan if the user move away from it!
        this.userMovingPlan = false;
        this.planInertiaCancelled = false;
        this.mouseDown = false;
        this.planMoveThresholdReached = false;

        this.singleTapTimeoutDelayMS = 200; // Change this if you feel like the double tap prevention is not timed correctly
        //@lastTapStamp = new Date 0 # Used to make singleTapEvent possible
        this.singleTapTimeoutID = null;



        this.settings = defaults(settings,
            { showDebugInfo: false }
        );

        // UI Controls
        this.eventLocationCtl = null; // UI Controls
        this.guidingArrows = {}; // UI Controls

        // We use this to evaluate if the drag is enough to prevent steady finger
        // Some of the phones are too much sensitive and we have to manage that.
        this.totalPlanDragDelta = new Vector2(0, 0);


        this.debugInfo = {
            visible: this.settings.showDebugInfo,
            infos: {}, // Info by names (Names are used so it's easy to edit them)
            tag: $('<div style="font-size:12px;position:absolute;top:5px;left:5px;background-color:white;color:blue;"></div>')
        };


        if (typeof requestAnimationFrame !== 'undefined' && requestAnimationFrame !== null) {
            this.debugInfo.infos['reqanimframe'] = "REQ ANIM";
        } else {
            this.debugInfo.infos['reqanimframe'] = "NO REQ ANIM";
        }


        this.containerTag = $(planContainerTag);
        this.planSpec = { width: 0, height: 0, ratio: 1 };
        //@planZoom = 1 # Default 100% zoom

        // Auto create all of the html elements that go inside the thing
        this._initLayers();

        // Connect the mouse events, interact js, jquery...
        this._initEvents();

        this.guidingArrows.eventArrow = new GuidingArrow(this.viewPortTag, 'eventLocationArrow');
        this.guidingArrows.eventArrow.visible = false; // Until the event location is set
        this.guidingArrows.eventArrow.onClick = (e, arrow) => {
            return this.moveToEvent();
        };
        this.guidingArrows.seatsArrow = new GuidingArrow(this.viewPortTag, 'seatLocationArrow');
        this.guidingArrows.seatsArrow.visible = false;
        this.guidingArrows.seatsArrow.onClick = (e, arrow) => {
            return this.moveToSeats();
        };


        this.steadyFinger = new SteadyFingerAnim(this.viewPortTag);
        this.ticketSearchFlash = new TicketFlashAnim(this.viewPortTag);
        this.placeIndicatorAnim = new PlaceIndicationAnim(this.viewPortTag);

        this.otherCtlsToRender = [this.steadyFinger, this.ticketSearchFlash, this.placeIndicatorAnim];

        // We add a slow re-render interval to make sure the plan is always up to date with things like a div being resized...
        this.refreshInterval = setInterval(this.triggerRedraw, 1000);
    }




    // For testing:
    // @contextMenu.showAt new Vector2(0, 0)

    setContextMenu(menuSettings: ContextMenuSettings) {
        return this.contextMenu = new ContextMenuControl(this, this.viewPortTag, menuSettings); // This is cheap, it leaves the controls in place if you change it.
    }

    showContextMenuAt(posVector) {
        return this.contextMenu.showAt(posVector);
    }

    // Call this for when you remove the plan from the screen.
    stop() {
        clearInterval(this.refreshInterval);
        return this.planInteract.unset();
    }
    // TODO: Unbind jquery events here...

    moveToEvent() {
        if (this.eventLocationCtl != null) {
            return this.move(this.eventLocationCtl.position.x, this.eventLocationCtl.position.y, 1500);
        }
    }

    moveToSeats() {
        if (this.seatsBoundingBox != null) {
            const seatsLocation = this.seatsBoundingBox.getCenter();
            return this.move(seatsLocation.x, seatsLocation.y, 1500);
        }
    }

    /**
     * 
     * @param center Target center of the view
     * @param zoom Target zoom. 1 is 100% zoom, 0.5 is 50% zoom
     * @param time Animation time
     * @returns 
     */
    moveToXYZoom(center: Vector2, zoom: number, time: number = 1500) {
        const centerV = new Vector2(center.x, center.y);

        const easeX = panim.getScaledEaseFunct(this.view.center.x, centerV.x, panim.easeInOutFast);
        const easeY = panim.getScaledEaseFunct(this.view.center.y, centerV.y, panim.easeInOutFast);
        const easeZoom = panim.getScaledEaseFunct(this.view.zoom, zoom, panim.easeInOutFast);
        return new panim.Anim(time, (t: number, _delta: number) => {
            this.view.center.x = easeX(t);
            this.view.center.y = easeY(t);
            this.view.zoom = easeZoom(t);
            return this.redraw();
        });
    }


    /**
     * Like moveToXYZoom but will zoom only if the desired zoom is bigger than the current zoom
     * This allows to easily focus on something but not zoom out if the user wanted be even closer
     */
    moveToXYZoomAtLeast(center: Vector2, zoom: number, time: number = 1500) {
        this.moveToXYZoom(center, Math.max(zoom, this.view.zoom), time);
    }
    

    moveToSeatsBySky() {
        if (this.seatsBoundingBox != null) {
            const seatsLocation = this.seatsBoundingBox.getCenter();
            return this.moveInSky(seatsLocation.x, seatsLocation.y, 1500).then(() => {
                return this.pointSomethingAt(seatsLocation);
            });
        }
    }

    moveToOverview(time?: number) {
        const center = this.view.planRect.getCenter();
        this.move(center.x, center.y, time);
        this.zoom(this.view.minZoom, time);
    }


    _initLayers() {
        // Create the view port
        this.viewPortTag = $('<div class="mobile-venue-plan-viewport" style="position:relative;overflow:hidden;width:100%;height:100%"></div>');
        this.containerTag.append(this.viewPortTag);


        this.view = new ViewPort(this.viewPortTag.width(), this.viewPortTag.height());
        this.view.viewPortTag = this.viewPortTag;
        //@view.center.x = 500
        //@view.center.y = 500

        // LAYER - Create the venue plan image tag
        this.planImgTag = $('<img style="position: absolute;" class="planimg"></img>');
        this.planImgTag[0].onload = e => {
            this.planSpec.width = this.planImgTag.width(); // plan unit (We base our plan unit on the picture's pixel size)
            this.planSpec.height = this.planImgTag.height(); // plan unit (We base our plan unit on the picture's pixel size)
            this.planSpec.ratio = this.planSpec.width / this.planSpec.height;
            this.view.setPlanSize(this.planSpec.width, this.planSpec.height);
            this.hideWait();
            if (this.onPlanLoaded) {
                this.onPlanLoaded();
                this.isPlanLoaded = true;
            }

            // This condition is just to remain compatible with the old code. We can remove it once we know the old
            // code has implemented the onPlanLoaded on its side and we can remove it from here.
            if (!this.onPlanLoaded)
                this.moveToSeatsBySky(); // Auto move the plan to the seats. The should be done on caller side instead.
        };


        // Load the image
        /* Seats positions
        <div id="seats"></div>
    
          
        <!-- Arrows -->
        <div id="arrows"></div>
                  
        <!-- Please wait -->
        <div id="waitMessage"></div>
        */

        this.planImgTag.attr("src", this.imgPath);
        this.viewPortTag.append(this.planImgTag);



        // LAYER - Load the canvas
        this.canvas = $('<canvas style="position:absolute;top: 0xp; left: 0px;width:100%; height:100%;"></canvas>')[0] as HTMLCanvasElement;
        this.viewPortTag.append(this.canvas);

        // LAYER - Load the please wait
        this.waitOverlayTag = $('<div class="waitOverlay show"></div>');
        this.waitSpinnerTag = $("<div class='spinner'></div>");
        this.waitOverlayTag.append(this.waitSpinnerTag);
        this.viewPortTag.append(this.waitOverlayTag);

        this.viewPortTag.append(this.debugInfo.tag);



        this._prepareStyle();

    }

    private _prepareStyle() {
        // Canvas items styles
        // Seats
        const cssAvailableSeatDummy = getStylingDummy('availableSeat');
        this.viewPortTag.append(cssAvailableSeatDummy);
        this.availableSeatStyle = cssDummyToStyle(cssAvailableSeatDummy);

        const cssAvailableSeatHoverDummy = getStylingDummy('availableSeatHover');
        this.viewPortTag.append(cssAvailableSeatHoverDummy);
        this.availableSeatHoverStyle = cssDummyToStyle(cssAvailableSeatHoverDummy);

        const cssProcessingSeatDummy = getStylingDummy('processingSeat');
        this.viewPortTag.append(cssProcessingSeatDummy);
        this.processingSeatStyle = cssDummyToStyle(cssProcessingSeatDummy);

        const cssSelectedSeatDummy = getStylingDummy('selectedSeat');
        this.viewPortTag.append(cssSelectedSeatDummy);
        this.selectedSeatStyle = cssDummyToStyle(cssSelectedSeatDummy);

        const cssUnavailableSeatDummy = getStylingDummy('unavailableSeat');
        this.viewPortTag.append(cssUnavailableSeatDummy);
        this.unavailableSeatStyle = cssDummyToStyle(cssUnavailableSeatDummy);

        const cssSectionButtonDummy = getStylingDummy(`section-button`);
        this.viewPortTag.append($(cssSectionButtonDummy));
        this.sectionButtonStyle[0] = cssDummyToStyle(cssSectionButtonDummy);

        const cssSectionButtonRightDummy = getStylingDummy(`section-button-right`);
        this.viewPortTag.append($(cssSectionButtonRightDummy));
        this.sectionButtonStyle[1] = cssDummyToStyle(cssSectionButtonRightDummy);
    }

    _initEvents() {

        // This variable is a patch used to compensate for the zoom gesture that is misled by the size of the inner div when it is zoomed.
        // The gesture tool keep the div size at the beginning of each gesture. We do the same and revert the delta scanling with it. 
        // It then becomes more natural
        var zoomGestureCtl = { startZoom: 1 }; 

        // Manage the events from Interact JS ******
        this.planInteract = interact(this.containerTag[0])
            .gesturable({

                listeners: {
                    start: (event) => {
                        //console.log("Drag start, interrupting steady finger anim", Date.now());
                        this.interruptSteadyFingerAnim();
                        zoomGestureCtl.startZoom = this.view.zoom; // Zoom compensation
                    },

                    move: (event) => {
                        const elOffset = getOffset(event.target);
                        
                        const pointOnView = new Vector2(event.pageX - elOffset.left, event.pageY - elOffset.top); // event.layerX, event.layerY
                        let newZoom = this.view.zoom + (event.ds * zoomGestureCtl.startZoom); // Zoom compensation

                        // If we have a mouse on the viewport, let's zoom according to the mouse position. We want to focus the mouse.
                        return this.zoomWithVPTarget(newZoom, pointOnView);
                    },
                },
            })
            
            .draggable({
                max: Infinity,
                inertia: false, // Turned off for the moment because of bad results when the plan goes beyond the boundaries
                manualStart: false, // Must be manual because of the samsung phone that are too fast on their repetitive finger event. IMPORTANT: The reasons why it won't work easily here as oposite to the interactjs website is that we combine a draggable with a tappable and a double tappable! It would work well on an IPhone and a Nexus so don't change this without testing a lot!

                onstart: event => {
                    this.totalPlanDragDelta = new Vector2(0, 0);
                    this.planInertiaCancelled = false;
                    this.planMoveThresholdReached = false; // Used to prevent the plan from moving if the user don't really moves his finger. If we make the plan move right away, it break the tap and double tap event especially on Samsung phones.
                    return this.onPlanManualMove();
                },

                onmove: event => {
                    let delta = { x: event.dx, y: event.dy };
                    const movingOnInertia = event.detail === "inertia";
                    this.userMovingPlan = !movingOnInertia; // The plan is clearly moving but if it's by inertia, it's not the user
                    this.totalPlanDragDelta = this.totalPlanDragDelta.add(new Vector2(event.dx, event.dy));

                    const planMoveThresholdReachedThisTime = this.totalPlanDragDelta.abs().max() > 10; // Calculate this
                    if (!this.planMoveThresholdReached && planMoveThresholdReachedThisTime) { // Detect that we reached it for the first time so we can adjust this delta specifically
                        this.planMoveThresholdReached = true; // OK until next dragStart!
                        delta = { x: this.totalPlanDragDelta.x + delta.x, y: this.totalPlanDragDelta.y + delta.y }; // Add the initial move so it look much more natural to the user. We do it only once because we move using a delta every times and not by an absolute position...
                    }

                    this.onPlanManualMove();
                    if (this.planMoveThresholdReached && (!movingOnInertia || (movingOnInertia && !this.planInertiaCancelled))) {
                        return this.moveVPDelta(delta.x, delta.y);
                    }
                },

                onend: event => {
                    this.userMovingPlan = false;
                    if(!this.planMoveThresholdReached) {
                        if ((this.singleTapTimeoutID == null)) {
                            //console.log("Drag end! Threshold not reached, so we trigger the tap event", event, event.pageX, event.pageY, event.target);

                            const elOffset = getOffset(event.target);
                            const pointOnView = new Vector2(event.pageX - elOffset.left, event.pageY - elOffset.top);
                            const pointOnPlan = this.view.pointVToP(pointOnView);
                            this.singleTapTimeoutID = setTimeout((() => this.handleSingleTap(pointOnPlan)), this.singleTapTimeoutDelayMS); // We need to delay in case the user is doing a double tap...
                        }
                        // If not reached, that was probably a TAP tentative. Let's trigger the tap event.
                        //this.handleTap(event);
                    }
                } // The user is clearly not moving the plan anymore!

            })
            
            .on('down', event => {
                this.planInertiaCancelled = false; // This is used to fix becasue when the inertia is still active and you grab the plan, dragstart is not called... If you find a way to stop the inertia when needed, it'll fix a couples of bugs
                const elOffset = getOffset(event.target);

                const pointOnView = new Vector2(event.pageX - elOffset.left, event.pageY - elOffset.top);
                const pointOnPlan = this.view.pointVToP(pointOnView); // event.layerX, event.layerY

                if ((event.which === 1) || (event.which === 0)) { // 1 is left mouse, 0 is any other single pointing device like a finger on a mobile screen
                    if(this.onLongClick != null) { // We don't want to trigger the long click if there's no callback
                        this.startSteadyFingerAnim(pointOnPlan);
                    }
                }
            })
            
            .on('up', event => {
                this.interruptSteadyFingerAnim();
                return this.triggerRedraw();

            }).on('tap', event => {
                return this.handleTap(event);
            });

        this.viewPortTag.on("mouseup", event => {
            this.interruptSteadyFingerAnim();
            return this.triggerRedraw();
        });

        this.viewPortTag.on("mousedown", event => { });

        this.viewPortTag.on("mousemove", event => {
            //@interruptSteadyFingerAnim()
            //console.log("Mouse move ", this.view.mousePos.toString(), this.selectedSeatsCtl);
            const tagOff = this.viewPortTag.offset();
            this.view.mousePos = new Vector2(event.pageX - tagOff.left, event.pageY - tagOff.top);

            // *******************
            // Mouse hover management
            // *******************
            const newHoverCtls: Control[] = [];

            // Sections
            const hoverSection = this.getSectionLabelsAtViewportPoint(this.view.mousePos);
            if (hoverSection) {
                // console.log("Hovering section ", hoverSection);
                newHoverCtls.push(hoverSection);
            }

            // TODO: One a a time here

            // Test seats
            if (!hoverSection) {
                const hoverSeat = this.getSeatsAtViewportPoint(this.view.mousePos);
                if (hoverSeat)
                    newHoverCtls.push(hoverSeat);
            }


            // Add other tests here

            // Apply changes to all components
            const oldHoverCtls = difference(this.hoverCtls, newHoverCtls);
            oldHoverCtls.forEach((ctl) => ctl.handleMouseOut(this.view, this.view.mousePos)); // The mouse pos here should be relative to the component
            const onlyNewHoverCtls = difference(newHoverCtls, this.hoverCtls);
            onlyNewHoverCtls.forEach((ctl) => ctl.handleMouseIn(this.view, this.view.mousePos)); // The mouse pos here should be relative to the component
            const hoverChanges = oldHoverCtls.length > 0 || onlyNewHoverCtls.length > 0;

            //if(oldHoverCtls.length > 0) console.log("Removing old hover ctls", oldHoverCtls);
            //if(onlyNewHoverCtls.length > 0) console.log("Adding new hover ctls", onlyNewHoverCtls);

            this.hoverCtls = newHoverCtls;
            if (hoverChanges)
                this.triggerRedraw();
        });

        this.viewPortTag.on("mouseout", event => {
            return this.view.mousePos = null;
        });

        //this.viewPortTag.on("mouseout", event => {});
        //@view.mousePos = null


        // Manage other events not handled by Interact JS ******
        this.viewPortTag.on("contextmenu", event => {
            const pointOnPlan = this.view.pointVToP(new Vector2(event.offsetX, event.offsetY));
            this.startTicketSearchFlash(pointOnPlan);
            if (this.onRightClick != null) {
                event.preventDefault();
                return this.onRightClick(pointOnPlan);
            }
        });


        return this.viewPortTag.on("wheel", event => {
            const oev = event.originalEvent as WheelEvent;
            const scrollValue = oev.deltaMode === 1 ? // in line of text
                oev.deltaY / 100
                : oev.deltaMode === 2 ? // In pages
                    oev.deltaY / 50
                    : // if oev.deltaMode is 0: in pixel
                    oev.deltaY / 1000;

            const zoomDelta = -scrollValue;

            const newZoom = this.view.zoom + zoomDelta;
            //zoomDelta = -event.originalEvent.deltaY
            //newZoom = @view  @view.zoomChangeForVPDist 1, zoomDelta

            // If we have a mouse on the viewport, let's zoom according to the mouse position. We want to focus the mouse.
            if (this.view.mousePos != null) {
                this.zoomWithVPTarget(newZoom, this.view.mousePos);
            } else {
                this.zoom(newZoom);
            }
            return event.preventDefault();
        });
    }

    getSeatsAtViewportPoint(point: Vector2) {
        return this.getCtlAtViewportPoint(this.selectedSeatsCtl, point);
    }
    getSeatsAtPlanPoint(point: Vector2) {
        return this.getCtlAtPlanPoint(this.selectedSeatsCtl, point);
    }

    getSectionLabelsAtViewportPoint(point: Vector2) {
        return this.getCtlAtViewportPoint(this.sectionsCtl, point);
    }
    getSectionLabelssAtPlanPoint(point: Vector2) {
        return this.getCtlAtPlanPoint(this.sectionsCtl, point);
    }

    getCtlAtViewportPoint<T extends Control>(ctlsToTest: T[], point: Vector2): T {
        if (ctlsToTest != null)
            return find(ctlsToTest, (ctl) => ctl.isViewportPointInside(this.view, point));
    }
    getCtlAtPlanPoint<T extends Control>(ctlsToTest: T[], point: Vector2): T {
        if (ctlsToTest != null)
            return find(ctlsToTest, (ctl) => ctl.isPlanPointInside(point));
    }



    // Single Tap - We have a concept around that because basically the TAP event is triggered twice on DoubleTap and we don't want this...
    handleTap(event) {
        if ((event.target.localName === "canvas") && ((event.button === undefined) || (event.button === 0))) { // Prevent reacting on context menu click or other items... Button is undefined when it's a real tap on a phone. button is 0 when it's a left mouse click on a computer...
            if ((this.singleTapTimeoutID == null)) {
                //console.log("TAP! ", event, event.pageX, event.pageY, event.target);

                const elOffset = getOffset(event.target);
                const pointOnView = new Vector2(event.pageX - elOffset.left, event.pageY - elOffset.top);
                const pointOnPlan = this.view.pointVToP(pointOnView);
                return this.singleTapTimeoutID = setTimeout((() => this.handleSingleTap(pointOnPlan)), this.singleTapTimeoutDelayMS); // We need to delay in case the user is doing a double tap...
            }
        }
    }

    //if new Date() - @lastTapStamp < @singleTapTimeoutDelayMS
    // This is a double tap


    //@lastTapStamp = new Date()

    handleSingleTap(pointOnPlan) {
        // Si on est en mode clickableSeatMode, on ne fait pas de flash
        if(!this.settings.clickableSeatMode)
            this.startTicketSearchFlash(pointOnPlan);

        this.singleTapTimeoutID = null; // Important because the content of this variable is used as a switch to better control the whole thing.

        this.handleSingleClick(pointOnPlan);
        /*
        if (this.onSingleClick != null) {
          return this.onSingleClick(pointOnPlan);
        }
        */
    }

    handleSingleClick(pointOnPlan) {
        if (this.settings.clickableSeatMode) {
            // Standardize this in a simple "Control" list
            // Test seats
            const clickedSection = this.getSectionLabelssAtPlanPoint(pointOnPlan);
            if (clickedSection && clickedSection.isClickable && this.onSectionClick != null) {
                return this.onSectionClick(clickedSection.section);
            }

            // Test seats
            const clickedSeat = this.getSeatsAtPlanPoint(pointOnPlan);

            if (clickedSeat && clickedSeat.isClickable && this.onSeatClick != null) {
                return this.onSeatClick(clickedSeat.seat);
            }
        } else {
            if (this.onSingleClick != null) {
                return this.onSingleClick(pointOnPlan);
            }
        }
    }

    onPlanManualMove() {
        if (this.planMoveThresholdReached) { // @totalPlanDragDelta.abs().max() > 10 # If we moved enough
            return this.interruptSteadyFingerAnim(); // We stop the steady finger!
        }
    }

    pointSomethingAt(pointOnPlan) {
        return this.placeIndicatorAnim.startAt(pointOnPlan, () => {
            return this.triggerRedraw();
        });
    }

    startSteadyFingerAnim(fingerPosOnPlan) {
        this.steadyFinger.startAt(fingerPosOnPlan, this.redraw, () => {
            this.onFingerHold(fingerPosOnPlan);
        });
    }

    interruptSteadyFingerAnim() {
        return this.steadyFinger.stop(this.triggerRedraw);
    }

    interruptSingleTap() {
        // Break single tap
        if (this.singleTapTimeoutID != null) {
            clearTimeout(this.singleTapTimeoutID);
            return this.singleTapTimeoutID = null; // Important because the content of this variable is used as a switch to better control the whole thing.
        }
    }


    onFingerHold(pointOnPlan) {
        if (this.onLongClick) {
            this.interruptSingleTap();
            this.startTicketSearchFlash(pointOnPlan);
            return this.onLongClick(pointOnPlan);
        }
    }

    startTicketSearchFlash(fingerPosOnPlan) {
        return this.ticketSearchFlash.startAt(fingerPosOnPlan, this.redraw);
    }

    triggerRedraw() {
        if ((this.nextRedrawEvent == null)) {
            //console.log(`Rerendering...`);
            return this.nextRedrawEvent = panim.reqAnimFrame(this.redraw);
        }
    }

    // This give the point where the view should be if the user scrolled away.
    // Returns null if not necessary
    get_BringBackView_Point(viewCenter, planRect) {
        // If view center is out of plan rect
        if (!planRect.hasPoint(viewCenter)) {
            // Create a line between center of the view and center of the plan
            const centerToCenterLine = new Line2D(viewCenter, planRect.getCenter());

            // Find we this line intersect with the plan rect
            return planRect.intersectsAtPoints(centerToCenterLine)[0]; // Considering the above statements, the line will intersect one time with one of the rect's side!
        } else {
            return null;
        }
    }

    redraw() {
        // This next line makes sure the view is always up to date with the actual size of the container for when the user resize the screen.
        this.view.setViewScreenSize(this.viewPortTag.width(), this.viewPortTag.height());

        let ctl, i;
        this.redrawCounter++;
        //@debugInfo.infos['redraw'] = "Redraw: #{@redrawCounter}"
        this.nextRedrawEvent = null; // Reset this
        const now = new Date().getTime();
        const delta = (now - this.lastFrameTime) / 1000;
        this.lastFrameTime = now;

        // console.log("Redrawing...");

        this.view.calc();
        this.arrowsTrackOnPlan = this.view.rect.pad(this.view.scalarVToP(this.arrowsTrackMargin)); // Calculate the arrows track on which the arrows will slide with a padding of X unit at view level
        this._calcArrows();

        // If the plan is out of view, trigger a recenter animation
        if ((this.autoMoveBackToPlanAnim == null) && !this.userMovingPlan) {  // If not already moving toward the center
            // See if we have a move to do and if so, what it is
            const shouldMoveToPoint = this.get_BringBackView_Point(this.view.center, this.view.planRect);
            if (shouldMoveToPoint != null) { // If there is really a move to make, let's do it
                this.planInertiaCancelled = true;
                const distanceToMove = this.view.center.distanceFrom(shouldMoveToPoint);
                if (distanceToMove > 5) {
                    this.autoMoveBackToPlanAnim = this.move(shouldMoveToPoint.x, shouldMoveToPoint.y, 200).then(() => {
                        return this.autoMoveBackToPlanAnim = null;
                    });
                }
            }
        } else if ((this.autoMoveBackToPlanAnim != null) && this.userMovingPlan) {
            this.autoMoveBackToPlanAnim.stop();
            this.autoMoveBackToPlanAnim = null;
        }
        // Plan - Plan is always 0, 0 in the virtual world
        const planScreenPos = this.view.pointPToV(new Vector2(0, 0));
        const planScreenSize = this.view.sizePToV(new Size2(this.planSpec.width, this.planSpec.height));

        /*
        @planImgTag.css
          left: planScreenPos.x
          top: planScreenPos.y
    
        @planImgTag.width(parseInt(planScreenSize.width))
        @planImgTag.height(parseInt(planScreenSize.height))
    
        */
        const planImgEl = this.planImgTag[0];
        planImgEl.style.left = planScreenPos.x.toString() + "px";
        planImgEl.style.top = planScreenPos.y.toString() + "px";

        planImgEl.style.width = planScreenSize.width.toString() + "px";
        planImgEl.style.height = planScreenSize.height.toString() + "px";


        // Scene location conversion
        const cCtx = this.canvas.getContext("2d");
        this.canvas.width = this.canvas.clientWidth;
        this.canvas.height = this.canvas.clientHeight;
        //cCtx.scale(@canvas.width, @canvas.height);

        // The event location
        if (this.eventLocationCtl != null) {
            this.eventLocationCtl.render(this.view, cCtx);
        }

        // Draw seats
        for (i in this.selectedSeatsCtl) {
            const ctl = this.selectedSeatsCtl[i];
            ctl.render(this.view, cCtx);
        }

        // Draw sections
        for (i in this.sectionsCtl) {
            const ctl = this.sectionsCtl[i];
            ctl.render(this.view, cCtx);
        }


        // The arrows
        for (let id in this.guidingArrows) {
            ctl = this.guidingArrows[id];
            ctl.render(this.view, cCtx);
        }

        for (i in this.otherCtlsToRender) {
            ctl = this.otherCtlsToRender[i];
            ctl.render(this.view, cCtx);
        }

        // Draw things!!
        this.drawDebugInfo(cCtx);
        // @drawSteadyFingerAnim cCtx
        // @drawTicketSearchFlash cCtx

        if (this.contextMenu != null) {
            return this.contextMenu.render(this.view, cCtx);
        }
    }

    _calcAndSetGuidanceArrowPositionAndAngle(arrowCtl, thingLocation) {
        const line_CenterToTheThing = new Line2D(this.view.rect.getCenter(), thingLocation); // Create a straight line between the center of the view port and the event location

        // Check intersect with rectangle
        const intersectPs = this.arrowsTrackOnPlan.intersectsAtPoints(line_CenterToTheThing);
        if (intersectPs.length > 0) {
            arrowCtl.position = intersectPs[0];
            return arrowCtl.angle = line_CenterToTheThing.getAngle();
        } else {
            return arrowCtl.visible = false;
        }
    }

    _calcArrows() {
        // Is event arrow visible
        let pos;
        this.guidingArrows.eventArrow.visible = false; // This is cheap but default to true for when we have no event location so it don't try to display an arrow for it...
        if (this.eventLocationCtl != null) {
            // Event arrow is visible only if the event location exist but is not currently visible in the view port!
            this.guidingArrows.eventArrow.visible = !this.view.rect.hasPoint(this.eventLocationCtl.position);
        }

        // Is seats arrow visible
        const seatsLocation = this.seatsBoundingBox?.getCenter();
        this.guidingArrows.seatsArrow.visible = false;
        if (seatsLocation != null) {
            this.guidingArrows.seatsArrow.visible = !this.view.rect.hasPoint(seatsLocation);
        }

        if (this.guidingArrows.eventArrow.visible) {
            pos = this._calcAndSetGuidanceArrowPositionAndAngle(this.guidingArrows.eventArrow, this.eventLocationCtl.position);
        }

        if (this.guidingArrows.seatsArrow.visible) {
            pos = this._calcAndSetGuidanceArrowPositionAndAngle(this.guidingArrows.seatsArrow, seatsLocation);
        }
    }

    drawDebugInfo(cCtx) {
        if (this.debugInfo.visible) {
            let wholeText = '';
            for (let i in this.debugInfo.infos) {
                const info = this.debugInfo.infos[i];
                wholeText += info + '<br />';
            }

            return this.debugInfo.tag.html(wholeText); // Clear this
        } else {
            return this.debugInfo.tag.html('');
        }
    }


    setEventLocation(point) {
        if (point != null) {
            return this.eventLocationCtl = new EventLocationControl(this.viewPortTag, new Vector2(point.x, point.y));
        } else {
            return this.eventLocationCtl = null;
        }
    }

    setSections(sections: PlanSection[]) {
        this.sections = sections;
        this.sectionsCtl = [];

        // Build the bouding box
        if (sections) {
            for (let i in sections) {
                const section = sections[i];

                // Create the controls to render
                const sectionCtl = new SectionControl(this, section, this.sectionButtonStyle);
                sectionCtl.triggerRedraw = this.triggerRedraw;

                this.sectionsCtl.push(sectionCtl);
            }
        }
    }

    // Seats: [ { id, x, y, size } ]
    setSeats(seats: PlanSeat[]) {
        // Keep that array
        // this.selectedSeats = seats;
        this.selectedSeatsCtl = [];
        this.selectedSeatsCtlById = {};

        // Build the bouding box
        if (seats) {
            for (let i in seats) {
                const seat = seats[i];

                // Create the controls to render
                const seatCtl = new SeatControl(this, seat);
                seatCtl.triggerRedraw = this.triggerRedraw;

                this.selectedSeatsCtl.push(seatCtl);
                this.selectedSeatsCtlById[seat.id] = seatCtl;

            }
        }

        // Reset the selection bounding box
        this.recalculateSelectedSeatBoundingBox();
    }

    setSelectedSeats(seatIds: number[]) {
        this.clearSelectedSeats();

        seatIds.forEach((seatId) => {
            const seatCtl = this.selectedSeatsCtlById[seatId];
            if (seatCtl) // IMPORTANT: We need to have the seats in the plan or this will skip them
                seatCtl.setState(SeatStatusEnum.SELECTED);
        });

        this.recalculateSelectedSeatBoundingBox();
        this.triggerRedraw();
    }

    setProcessingSeats(seatIds: number[]) {
        seatIds.forEach((seatId) => {
            const seatCtl = this.selectedSeatsCtlById[seatId];
            if (seatCtl) // IMPORTANT: We need to have the seats in the plan or this will skip them
                seatCtl.setState(SeatStatusEnum.PROCESSING);
        });

        this.recalculateSelectedSeatBoundingBox();
        this.triggerRedraw();
    }


    getSeatsByState(state: SeatStatusEnum) {
        return this.getSeatCtlsByState(state).map((seatCtl) => seatCtl.seat);
    }

    getSeatCtlsByState(state: SeatStatusEnum) {
        return this.selectedSeatsCtl.filter((seatCtl) => seatCtl.seat.state === state);
    }

    clearSelectedSeats() {
        const seatCtls = this.getSeatCtlsByState(SeatStatusEnum.SELECTED);
        seatCtls.forEach((seatCtl) => seatCtl.setState(SeatStatusEnum.AVAILABLE))
        if (seatCtls.length > 0) {
            this.recalculateSelectedSeatBoundingBox();
            this.triggerRedraw();
        }
    }

    clearProcessingSeats() {
        const seatCtls = this.getSeatCtlsByState(SeatStatusEnum.PROCESSING);
        seatCtls.forEach((seatCtl) => seatCtl.setState(SeatStatusEnum.AVAILABLE))
        if (seatCtls.length > 0) {
            this.triggerRedraw();
        }
    }

    recalculateSelectedSeatBoundingBox() {
        this.seatsBoundingBox = null;

        const selectedSeats = this.getSeatsByState(SeatStatusEnum.SELECTED);
        if (selectedSeats.length > 0)
            this.seatsBoundingBox = getSeatBoudingBox(selectedSeats[0]);

        drop(selectedSeats, 1)
            .forEach((seat) => {
                this.seatsBoundingBox = this.seatsBoundingBox.includeRect(getSeatBoudingBox(seat));
            });
    }

    /*
    changeSeat(seat: PlanSeat) {
      this.selectedSeatsCtlById[seat.id]
      this.selectedSeatsCtl.push(seatCtl);
    }
    */

    public getSeatStyle(seatStatus: SeatStatusEnum) {
        switch (seatStatus) {
            case SeatStatusEnum.AVAILABLE:
                return [ this.availableSeatStyle, this.availableSeatHoverStyle ];
            case SeatStatusEnum.PROCESSING:
                return [ this.processingSeatStyle, this.processingSeatStyle ];
            case SeatStatusEnum.SELECTED:
                return [ this.selectedSeatStyle, this.availableSeatHoverStyle ];
            case SeatStatusEnum.UNAVAILABLE:
                return [ this.unavailableSeatStyle, this.unavailableSeatStyle ];
            default:
                return [ this.selectedSeatStyle, this.selectedSeatStyle ]; // Backward compatibility Always used to work with selected seat only
        }
    }

    // Move the plan by viewport level delta
    moveVPDelta(dx: number, dy: number) {
        this.view.center = this.view.center.add(this.view.vectorVToP(new Vector2(-dx, -dy)));
        //@triggerRedraw()
        return this.redraw();
    }

    // Move the plan to a specific point on plan
    move(x: number, y: number, time: number = null) {
        if (time != null) {
            const easeX = panim.getScaledEaseFunct(this.view.center.x, x, panim.easeInOutFast);
            const easeY = panim.getScaledEaseFunct(this.view.center.y, y, panim.easeInOutFast);
            return new panim.Anim(time, (t: number, _delta: number) => {
                this.view.center.x = easeX(t);
                this.view.center.y = easeY(t);
                return this.redraw();
            });

        } else {
            this.view.center.x = x;
            this.view.center.y = y;
            return this.triggerRedraw();
        }
    }

    zoom(zoom: number, time: number = null) {
        const restrictedZoom = this.view.getRestrictedZoom(zoom);

        if (time != null) {
            const easeZoom = panim.getScaledEaseFunct(this.view.zoom, restrictedZoom, panim.easeInOutFast);
            return new panim.Anim(time, (t: number, _delta: number) => {
                this.view.zoom = easeZoom(t);
                return this.redraw();
            });
        } else {
            this.view.zoom = restrictedZoom;
            return this.triggerRedraw();
        }
    }

    zoomWithVPTarget(zoom, viewPortTargetPoint, time = null) {
        const restrictedZoom = this.view.getRestrictedZoom(zoom);

        // Save the target on plan so we can try to keep it at it's place on screen
        const targetOnPlan = this.view.pointVToP(viewPortTargetPoint);  // This target will have to remain the same
        // Take the target

        const operation = zoomToSet => {
            this.view.zoom = zoomToSet;
            this.view.calc(); // Recalc the view take consider the new zoom for the following calculs
            // Move the center of the plan accordingly
            // Find where the new wrong target is falling on the plan
            const newTargetErrorVector = targetOnPlan.sub(this.view.pointVToP(viewPortTargetPoint));
            this.view.center = this.view.center.add(newTargetErrorVector);
            return this.triggerRedraw(); // TODO: Could be find to use @redraw when used in the animation...
        };

        if (time != null) {
            const easeZoom = panim.getScaledEaseFunct(this.view.zoom, restrictedZoom, panim.easeInOutFast);
            return new panim.Anim(time, (t, delta) => {
                return operation(easeZoom(t));
            });
        } else {
            return operation(restrictedZoom);
        }
    }

    moveInSky(x: number, y: number, time: number) {
        // Take the ideal sky zoom and adjust it so we don't to high in the sky for no good reason. The user often finds himself exactly at the place he want its ticket to be.
        // We take the current zoom which we want to start from, we divide the distance to move and substract it to the zoom to get the sky zoom proportional to our distance.
        // Note that a negative number means far from the plan, positive numbers mean closer
        const distToMove = this.view.center.distanceFrom(new Vector2(x, y));

        // Calculate how much we can sky zoom according to the current zoom
        const maxZoomChange = this.view.idealSkyZoom - this.view.zoom; // 0.30 - 0.54 = -0.24

        // When we move under a small range, we don't want a full sky zoom because its ugly... so we kinda calculate a percentage of that max zoom change according to the distance
        let percentageOfZoomChange = distToMove / 200; // The divider here is the distance threshold from which we want a fulllll sky zoom
        if (percentageOfZoomChange > 1) { percentageOfZoomChange = 1; } // Clip the percentage too 100%
        const zoomChange = maxZoomChange * percentageOfZoomChange;

        // Calculate the final zoom we are gonna use
        const bestSkyZoom = this.view.zoom + zoomChange;

        const easeX = panim.getScaledEaseFunct(this.view.center.x, x, panim.easeInOutFast);
        const easeY = panim.getScaledEaseFunct(this.view.center.y, y, panim.easeInOutFast);
        const easeZoom = panim.getScaledEaseFunct(this.view.zoom, bestSkyZoom, panim.easeInOutInFast);
        return new panim.Anim(time, (t: number, delta: number) => {
            this.view.center.x = easeX(t);
            this.view.center.y = easeY(t);
            this.view.zoom = easeZoom(t);

            return this.redraw();
        });
    }

    showWait() {
        return this.waitOverlayTag.addClass("show");
    }

    hideWait() {
        return this.waitOverlayTag.removeClass("show");
    }



    // Move view to seats
    zoomToSeats() { }

    // Move view to scene
    zoomToScene() { }
}

//module.exports.GestureVenuePlan = GestureVenuePlan;

export type PlanSpec = {
    width: number,
    height: number,
    ratio: number
}


